<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
      alt="Close Icon">
    <div class="modal-header">
      <h4 class="modal-heading">Change Your Name</h4>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <p class="smaller text-content">Update your current name</p>

        <form [formGroup]="nameForm">
          <label class="outlined-input">
            <input type="text" formControlName="firstName" placeholder=" ">
            <span>First Name</span>
          </label>

          <p *ngIf="nameForm.controls.firstName.touched && nameForm.controls.firstName.hasError('required')"
            class="validation-message">
            First Name is required
          </p>

          <p *ngIf="nameForm.controls.firstName.touched && nameForm.controls.firstName.hasError('pattern')"
            class="validation-message">
            First Name is invalid
          </p>

          <label class="outlined-input second">
            <input type="text" formControlName="lastName" placeholder=" ">
            <span>Last Name</span>
          </label>

          <p *ngIf="nameForm.controls.lastName.touched && nameForm.controls.lastName.hasError('required')"
            class="validation-message">
            Last Name Password is required
          </p>

          <p *ngIf="nameForm.controls.lastName.touched && nameForm.controls.lastName.hasError('pattern')"
            class="validation-message">
            Last Name Password is invalid
          </p>
        </form>
      </div>

      <div class="modal-actions">
        <button class="button primary" (click)="updateName()">update</button>
        <button class="button tertiary" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
